import { call, put, takeEvery } from 'redux-saga/effects';
import {
  ISalesDistrictDealerGoal,
  salesAdminActionCreators,
  SalesAdminActionKeys,
  SaveSalesDistrictDealerGoal
} from '..';
import { IApiExecuteRespone } from '../../apiInterfaces';
import { showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import { saveSalesDistrictGoal } from '../salesAdminApi';

function* saveSalesDistrictDealerGoalSaga(action: SaveSalesDistrictDealerGoal) {
  yield put(uiActionCreators.showSpinnerDialog());

  const response: IApiExecuteRespone<ISalesDistrictDealerGoal> = yield call(saveSalesDistrictGoal, action.payload);

  if (response.requestFailed) {
    yield showFailedRequestDialog(response);
  } else if (response.value) {
    yield put(salesAdminActionCreators.removeSalesDistrictGoal(action.payload.old));
    yield put(salesAdminActionCreators.setSalesDistrictGoals([response.value]));
  }

  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchSaveSalesDistrictDealerGoal() {
  yield takeEvery(SalesAdminActionKeys.SAVE_SALES_DISTRICT_GOAL, saveSalesDistrictDealerGoalSaga);
}
